import classNames from 'classnames'
import { JSX, ReactNode, useCallback, MouseEvent } from 'react'
import { PopoverPanelProps, Popover, PopoverButton, PopoverPanel } from '@headlessui/react'
import { ExclamationCircleIcon, InformationCircleIcon } from '@heroicons/react/16/solid'

type InfoProps = {
    small?: boolean
    anchor?: PopoverPanelProps['anchor']
    className?: string
    badge?: ReactNode
    error?: boolean
    children?: ReactNode
}

export const InfoBadge = ({ small, anchor = 'bottom', className, badge, error, children }: InfoProps): JSX.Element => {
    const handleClick = useCallback((evt: MouseEvent<HTMLDivElement>) => {
        evt.stopPropagation()
    }, [])

    const Icon = error ? ExclamationCircleIcon : InformationCircleIcon

    return (
        <Popover className="relative leading-none">
            {({ open }) => (
                <>
                    <PopoverButton as="div" className={classNames(className, 'cursor-pointer')} onClick={handleClick}>
                        {badge ? (
                            badge
                        ) : (
                            <Icon
                                className={classNames('rounded-full', {
                                    'size-[14px]': small,
                                    'size-[16px]': !small,
                                    // -- info / default
                                    'text-secondary hover:text-blue-500': !error && !open,
                                    '!text-blue-700': !error && open,
                                    // -- error
                                    'text-error-400 hover:text-error-600': error && !open,
                                    'text-error-700': error && open,
                                })}
                            />
                        )}
                    </PopoverButton>
                    <PopoverPanel
                        className="text-primary z-10 rounded-md bg-neutral-900 p-3 text-xs font-normal text-white shadow-sm dark:bg-neutral-50 dark:text-black"
                        portal
                        anchor={anchor}
                    >
                        <div onClick={handleClick} className="max-w-xs whitespace-pre-wrap">
                            {children}
                        </div>
                    </PopoverPanel>
                </>
            )}
        </Popover>
    )
}
